import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Savings from './components/Savings';
import Features from './components/Features';
import Producer from './components/Producer';
import ProductCatalog from './components/ProductCatalog';
import TowelDryers from './components/TowelDryers';
import UsageGallery from './components/UsageGallery';
import ContactForm from './components/ContactForm';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';
import ImageGallery from './components/ImageGallery';
import './styles/App.css';

function AppContent() {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showGallery, setShowGallery] = useState(false);
  const [initialImageIndex, setInitialImageIndex] = useState(0);

  const handleProductClick = (product, startIndex = 0) => {
    setSelectedProduct(product);
    setInitialImageIndex(startIndex);
    setShowGallery(true);
  };

  const handleCloseGallery = () => {
    setShowGallery(false);
    setSelectedProduct(null);
    setInitialImageIndex(0);
  };

  return (
    <div className="App">
      <Header />
      <Hero />
      <ProductCatalog onProductClick={handleProductClick} />
      <TowelDryers onProductClick={handleProductClick} />
      <UsageGallery onImageClick={handleProductClick} />
      <ContactForm />
      <CallToAction />
      <About />
      <Savings />
      <Features />
      <Producer />
      <Footer />

      {showGallery && selectedProduct && (
        <ImageGallery
          product={selectedProduct}
          initialIndex={initialImageIndex}
          onClose={handleCloseGallery}
        />
      )}
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Routes>
        <Route path="/ru/*" element={<AppContent />} />
        <Route path="/*" element={<AppContent />} />
      </Routes>
    </LanguageProvider>
  );
}

export default App;
